import React from "react";

type Props = {
    children: React.ReactNode;
}

function WarningAlert(props: Props) {
    return <div className="alert alert-warning">{props.children}</div>;
}

export default WarningAlert;
